import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    salesChannelId: 'a332da49-a665-4a13-bd44-1ecea09b4d86',
    countryCodes: ['FR'],
    locale: 'fr-FR',
    isPrive: true,
});
